// Access value 
export const GET_ACCESS_GROUP_VALUE = "GET_ACCESS_GROUP_VALUE"
export const GET_ACCESS_GROUP_VALUE_SUCCESS = "GET_ACCESS_GROUP_VALUE_SUCCESS"
export const GET_ACCESS_GROUP_VALUE_ERROR = "GET_ACCESS_GROUP_VALUE_ERROR"

//Update Access value
export const UPDATE_ACCESS_GROUP_VALUE = "UPDATE_ACCESS_GROUP_VALUE"
export const UPDATE_ACCESS_GROUP_VALUE_SUCCESS = "UPDATE_ACCESS_GROUP_VALUE_SUCCESS"
export const UPDATE_ACCESS_GROUP_VALUE_ERROR = "UPDATE_ACCESS_GROUP_VALUE_ERROR"